import {ReactComponent as MiniRobotIcon} from '../assets/images/icons/mini-robot.svg'
import {ReactComponent as SmartRobotIcon} from '../assets/images/icons/smart-robot.svg'
import {ReactComponent as ChiefRobotIcon} from '../assets/images/icons/chief-robot.svg'

export default [
  {
    id: 1,
    title: 'Mini',
    Icon: MiniRobotIcon,
    unique: '1 unique page',
    description: 'Simple, intuitive one page website providing essential functionality to promote your business.',
    period: '2 weeks',
    price: '5,000',
  },
  {
    id: 2,
    title: 'Smart',
    Icon: SmartRobotIcon,
    unique: '1 - 3 unique pages',
    description: 'Larger scale website with all required functionality to present your business in details.',
    period: '3 weeks',
    price: '10,000',
  },
  {
    id: 3,
    title: 'Chief',
    Icon: ChiefRobotIcon,
    unique: '3 - 8 unique pages',
    description: 'Comprehensive full featured website covering all aspects and needs of your business. ',
    period: '4+ weeks',
    price: '15,000',
  },
]
